export enum LanguagesEnum {
  MG = 'mg',
  FR = 'fr',
  EN = 'en',
}

export enum PrefixEnum {
  LEGAL_STATUSES = 'Legal-status-choices_',
}
